<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6"
     *ngIf="serverError === null">

  <h2>
    Payments
    <span *ngIf="loadingPayments" class="text-secondary">- Loading...</span>
    <span *ngIf="!loadingPayments && paymentList && paymentList.results">({{ paymentList.count.toLocaleString() }})</span>
  </h2>

  <div class="alert customer-alert text-center" role="alert"
       [class.alert-success]="modalResult.status === CallbackResultStatus.success"
       *ngIf="modalResult !== null">
    {{ modalResult.text }}
  </div>

  <div class="row">
    <div class="col-xl-5 col-12 mb-3">
      <input type="text" class="form-control"
             placeholder="Filter payments by product, invoice #, and linked customer"
             [(ngModel)]="filters.search"
             (ngModelChange)="handleFilterChange()">
    </div>
    <div class="col-xl-7 col-12 mb-3 clearfix">
      <button class="btn btn-outline-primary mr-2" type="button"
              [disabled]="loadingQueriesNeededForFilters()"
              [class.disabled]="loadingQueriesNeededForFilters()"
              (click)="openEditFiltersModal()">
        {{ loadingQueriesNeededForFilters() ? 'Loading...' : 'Edit Filters' }}
      </button>
      <button class="btn btn-outline-primary mr-2" type="button"
              [disabled]="loadingPayments"
              [class.disabled]="loadingPayments"
              (click)="openExportListModal()">
        Export List
      </button>
      <button class="btn btn-outline-primary mr-2" type="button"
              [disabled]="loadingSavedView"
              [class.disabled]="loadingSavedView"
              (click)="openSelectReportColumnsModal()">
        Configure Columns
      </button>
      <button class="btn btn-outline-primary" type="button"
              [disabled]="loadingSavedView"
              [class.disabled]="loadingSavedView"
              (click)="openSavedViewsModal()">
        Saved Views
      </button>
    </div>
  </div>

  <div *ngIf="getActiveFilters().length > 0" class="clearfix mb-2">
    <span *ngFor="let activeFilter of getActiveFilters()"
          class="filter-item mb-2 mr-2 cursor-pointer"
          (click)="openEditFiltersModal()">{{ activeFilter }}</span>
  </div>

  <app-saved-report-view-toolbar
    [savedView]="savedView"
    [loadingSavedView]="loadingSavedView"
    [savedViewEdited]="savedViewEdited"
    [personalDefaultViewId]="defaultReportViewId"
    [organizationDefaultViewId]="organizationDefaultReportViewId"
    (renameView)="openRenameSavedViewModal()"
    (deleteView)="deleteSavedView()"
    (saveChanges)="updateSavedView()"
    (saveAsNew)="openCreateSavedViewModal()">
  </app-saved-report-view-toolbar>

  <div class="rounded-table-wrapper table-responsive">
    <table class="table table-hover">

      <thead>
      <tr>
        <th *ngFor="let col of columns; let first = first;"
            scope="col"
            class="text-nowrap"
            [class.sticky-column-left]="first">
          {{ ReportColumns.COLUMN_HEADER_OVERRIDES[col] || col }}
        </th>
        <th scope="col" class="text-nowrap sticky-column-right"></th>
      </tr>
      </thead>

      <tbody *ngIf="paymentResultsPresent()" style="line-height: 16px;">
      <ng-template #customCell let-payment="row" let-col="col">
        <ng-container [ngSwitch]="col">
          <ng-container *ngSwitchCase="ReportColumns.COLUMN_NAME_TIME">
            <span class="text-nowrap">
              {{ timeStringFromISO8601(payment.created_at) }}
            </span>
          </ng-container>
          <ng-container *ngSwitchCase="ReportColumns.COLUMN_NAME_INVOICE_DESCRIPTION">
            <a *ngIf="getSingleBookingId(payment) !== null && payment.invoice_description"
               [routerLink]="['/reporting/bookings']"
               [queryParams]="getBookingQueryParams(payment)"
               target="_blank">{{ payment.invoice_description }}</a>
            <ng-container *ngIf="getSingleBookingId(payment) === null">{{ payment.invoice_description }}</ng-container>
            <span *ngIf="!payment.invoice_description" class="text-muted">No data</span>
            <ng-container *ngIf="payment.discount_amount">
              <br>
              <span class="text-muted d-inline-block mt-1">
                <span class="text-nowrap">
                  {{ orgConfigService.getCurrencySymbol() }}{{ payment.discount_amount }} discount applied:
                </span>
                {{ payment.discount_display_name }}
              </span>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="ReportColumns.COLUMN_NAME_LINKED_CUSTOMER">
            <app-nullable-customer-link [customerId]="payment.customer_id"
                                        [firstName]="payment.customer_first_name"
                                        [lastName]="payment.customer_last_name"
                                        section="payments"
                                        fallbackText="Not linked"></app-nullable-customer-link>
          </ng-container>
          <ng-container *ngSwitchCase="ReportColumns.COLUMN_NAME_AMOUNT">
            <span [class.cm-strikethrough]="(payment.status === PaymentStatus.partiallyRefunded) || (payment.status === PaymentStatus.refunded) || (payment.status === PaymentStatus.paymentFailed)">
              {{ orgConfigService.getCurrencySymbol() }}{{ payment.amount }}
            </span>
            <ng-container *ngIf="payment.status === PaymentStatus.partiallyRefunded">
              <br>
              <span class="text-muted d-inline-block mt-1">
                Partially refunded ({{ orgConfigService.getCurrencySymbol() }}{{ payment.amount_refunded }})
              </span>
            </ng-container>
            <ng-container *ngIf="payment.status === PaymentStatus.refunded">
              <br>
              <span class="text-muted d-inline-block mt-1">
                Refunded
              </span>
            </ng-container>
            <ng-container *ngIf="payment.status === PaymentStatus.paymentProcessing">
              <br>
              <span class="text-warning d-inline-block mt-1">
                Processing
              </span>
            </ng-container>
            <ng-container *ngIf="payment.status === PaymentStatus.paymentFailed">
              <br>
              <span class="text-danger d-inline-block mt-1">
                Failed
              </span>
            </ng-container>
            <ng-container *ngIf="payment.pending_refund_amount != null">
              <br>
              <span class="text-warning d-inline-block mt-1">
                Refund of {{ orgConfigService.getCurrencySymbol() }}{{ payment.pending_refund_amount }} awaiting confirmation from MX Merchant
              </span>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="ReportColumns.COLUMN_NAME_PAYMENT_METHOD">
            {{ getPaymentMethodTypeDisplay(payment.payment_type, payment.payment_method_type) }}
            <!--suppress TypeScriptValidateTypes -->
            <ng-container *ngIf="[PaymentType.stripe, PaymentType.gravity, PaymentType.mxMerchant, PaymentType.mock].includes(payment.payment_type)">
              <ng-container *ngIf="(payment.payment_method_type === PaymentMethodType.card) && payment.credit_card_last4">
                <br>
                <span class="text-muted d-inline-block mt-1">
                  <span style="text-transform: capitalize" *ngIf="payment.credit_card_brand">{{ payment.credit_card_brand }}</span>
                  ending in {{ payment.credit_card_last4 }}
                </span>
              </ng-container>
              <ng-container *ngIf="(payment.payment_method_type === PaymentMethodType.bankAccount) && payment.bank_account_last4">
                <br>
                <span class="text-muted d-inline-block mt-1">
                  <span style="text-transform: capitalize" *ngIf="payment.bank_account_bank_name">{{ payment.bank_account_bank_name }}</span>
                  ending in {{ payment.bank_account_last4 }}
                </span>
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="ReportColumns.COLUMN_NAME_FACILITATING_STAFF_USER">
            <span *ngIf="payment.staff_user_id">
              {{ getStaffNameDisplay(payment.staff_user_first_name, payment.staff_user_last_name, payment.staff_user_email) }}
            </span>
            <span *ngIf="!payment.staff_user_id" class="text-muted">
              None
            </span>
          </ng-container>
        </ng-container>
      </ng-template>
      <tr *ngFor="let payment of paymentList.results">
        <td *ngFor="let col of columns; let first = first;"
            [class.sticky-column-left]="first">
          <app-report-cell [column]="col"
                           [row]="payment"
                           [getContentItem]="getContentItem"
                           [customColumns]="ColumnsWithCustomHTML"
                           [objectIDColumns]="ObjectIDColumns"
                           [currencyColumns]="CurrencyColumns"
                           [dateColumns]="DateColumns"
                           [customTemplate]="customCell"></app-report-cell>
        </td>

        <td class="table-button-cell sticky-column-right">
          <div class="dropdown dropleft">
            <button class="btn btn-sm btn-secondary table-12px-button float-right dropdown-toggle"
                    type="button" id="managePaymentDropdown{{ payment.id }}"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Manage
            </button>
            <div class="dropdown-menu" attr.aria-labelledby="managePaymentDropdown{{ payment.id }}">
              <a class="dropdown-item" href="#"
                 *ngIf="!isPOSPayment(payment)"
                 (click)="downloadReceipt(payment);$event.preventDefault();">
                Download
                <span *ngIf="orgConfigService.getOrganizationConfig().tax_display_format === TaxDisplayFormat.vat">VAT</span>
                <span *ngIf="orgConfigService.getOrganizationConfig().tax_display_format === TaxDisplayFormat.gst">GST</span>
                Receipt
              </a>
              <a class="dropdown-item" href="#"
                 *ngIf="canRefundPayment(payment)"
                 (click)="openRefundPaymentModal(payment);$event.preventDefault();">
                View Refund Options
              </a>
              <a class="dropdown-item" href="#"
                 *ngIf="canChangePaymentCustomer(payment) && accountService.getMyAccount().can_manage_members"
                 (click)="openChangePaymentCustomerModal(payment);$event.preventDefault();">
                Change Linked Customer
              </a>
              <a class="dropdown-item" href="#"
                 (click)="openPaymentDetailsModal(payment);$event.preventDefault();">
                View Details
              </a>
            </div>
          </div>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="!paymentResultsPresent()">
      <tr>
        <td colspan="99">
          {{ loadingPayments ? 'Loading...' : 'No payments' }}
        </td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="row">
    <div class="col-sm mb-2">
      <label for="resultsPerPage" class="pr-1 align-middle">
        Results per page:
      </label>
      <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
              [(ngModel)]="paymentsPageSize" (change)="pageNumber = 1;loadReport()">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <div class="col-sm">
      <nav aria-label="Pagination">
        <ul class="pagination justify-content-end">
          <li class="page-item" [class.disabled]="pageNumber <= 1">
            <button class="page-link" aria-label="Previous" [disabled]="pageNumber <= 1"
               (click)="setPage(pageNumber - 1)">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 2">
            <button class="page-link" (click)="setPage(pageNumber - 2)">
              {{ pageNumber - 2 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 1">
            <button class="page-link" (click)="setPage(pageNumber - 1)">
              {{ pageNumber - 1 }}
            </button>
          </li>
          <li class="page-item active" aria-current="page">
            <button class="page-link" disabled>
              {{ pageNumber }}
              <span class="sr-only">(current)</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
            <button class="page-link" (click)="setPage(pageNumber + 1)">
              {{ pageNumber + 1 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
            <button class="page-link" (click)="setPage(pageNumber + 2)">
              {{ pageNumber + 2 }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
            <button class="page-link" aria-label="Next" [disabled]="pageNumber >= lastPageNumber()"
               (click)="setPage(pageNumber + 1)">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <div class="floating-alert-container">
    <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
      {{ successMessage }}
      <button type="button" class="close" (click)="successMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-info" role="alert" *ngIf="loadingDownload">
      Downloading...
    </div>
  </div>

</div>
